import AddToCart from '../AddToCart'
import { Button, OldText } from '@gassan-ui'
import { Article } from '@generated'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { cn } from '@lib/cn'

type Props = Article & {
  usps: string[]
  handleMakeAppointment: () => void
  handleGetInContact: () => void
}

const Buttons: FC<Props> = ({ usps, handleMakeAppointment, handleGetInContact, ...rest }) => {
  const { t } = useTranslation('product-detail')

  const uspArray = usps.filter((n) => n)

  return (
    <>
      <div
        className={cn(
          'mt-2 grid gap-x-6 gap-y-3',
          'sm:mt-4 sm:grid-cols-1 sm:gap-y-1',
          'lg:mt-5 lg:grid-cols-1',
        )}
      >
        <AddToCart articleId={rest.id} />
        <Button variant="outline" onClick={handleGetInContact} className="w-full">
          {t('getInContact')}
        </Button>
      </div>
      <OldText mb="0" mt="1.5rem" as="div">
        <ul>
          {uspArray.map((usp, index) => (
            <li key={`usp_${index}`}>{usp}</li>
          ))}
        </ul>
      </OldText>
    </>
  )
}

export default Buttons
